<template>
  <aside class="sidebar">
    <ProductInfo
      v-for="product in products"
      :key="product.name"
      :product="product"
    />
  </aside>
</template>

<script>
import { mapGetters } from 'vuex';

import ProductInfo from '@/components/ProductInfo.vue';

export default {
  name: 'Sidebar',
  components: {
    ProductInfo,
  },
  computed: {
    ...mapGetters(['products']),
  },
};
</script>

<style lang="less" scoped>
.sidebar {
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
